import React from "react";
import { ArrowDownIcon } from "lucide-react";
type OfferScrollButtonProps = {
  className?: string;
};
export function OfferScrollButton({
  className = ""
}: OfferScrollButtonProps) {
  return <a href="#offre" onClick={e => {
    const target = document.getElementById("offre");
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }} className={`inline-flex items-center justify-center gap-2 rounded-full bg-gold px-8 py-4 text-base font-bold tracking-wide text-ink transition-transform duration-150 ease-out hover:-translate-y-0.5 active:scale-[0.98] sm:text-lg ${className}`} data-id="element-104" data-mp="gu9u0w0yl7jr">
      VOIR L'OFFRE COMPLÈTE
      <ArrowDownIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-105" data-mp="1x92asirpcla" />
    </a>;
}